// extracted by mini-css-extract-plugin
module.exports = {"deviceMainContent":"devices_deviceMainContent__MmZP0"};